/* =============================================
   R.DSTG — Shopify Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- NAV SCROLL ---- */
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- MOBILE MENU ---- */
  var navToggle     = document.getElementById('navToggle');
  var mobileMenu    = document.getElementById('mobileMenu');
  var mobileOverlay = document.getElementById('mobileOverlay');
  var menuClose     = document.getElementById('mobileMenuClose');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (navToggle)     navToggle.addEventListener('click', openMobileMenu);
  if (menuClose)     menuClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobileMenu);
    });
  }

  /* ---- SEARCH BAR ---- */
  var searchToggle = document.getElementById('searchToggle');
  var searchBar    = document.getElementById('searchBar');
  var searchClose  = document.getElementById('searchClose');
  var searchInput  = searchBar ? searchBar.querySelector('.search-bar__input') : null;

  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('open');
    searchBar.setAttribute('aria-hidden', 'false');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchBar) return;
    searchBar.classList.remove('open');
    searchBar.setAttribute('aria-hidden', 'true');
    hideSuggestions();
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  /* ---- CART DRAWER ---- */
  var cartDrawer  = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartToggle  = document.getElementById('cartToggle');
  var cartClose   = document.getElementById('cartClose');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- ESCAPE KEY (centralisé) ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchBar && searchBar.classList.contains('open')) { closeSearch(); return; }
    if (cartDrawer && cartDrawer.classList.contains('open')) { closeCart(); return; }
    if (mobileMenu && mobileMenu.classList.contains('open')) closeMobileMenu();
    var lightbox = document.getElementById('imgLightbox');
    if (lightbox && lightbox.classList.contains('open')) {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  /* ---- ADD TO CART (AJAX) ---- */
  function doAddToCart(variantId, btn) {
    if (!variantId) return;
    var origText = btn ? btn.textContent : 'Ajouter au panier';
    if (btn) { btn.textContent = 'Ajout...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btn) {
        btn.textContent = 'Ajouté ✓';
        setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
      }
      openCart();
    })
    .catch(function (err) {
      console.error('Cart error:', err);
      if (btn) { btn.textContent = 'Erreur — réessayer'; btn.disabled = false; }
    });
  }

  var addToCartBtn = document.getElementById('addToCartBtn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      var variantId = document.getElementById('selectedVariantId')
        ? parseInt(document.getElementById('selectedVariantId').value)
        : parseInt(this.dataset.variantId);
      doAddToCart(variantId, this);
    });
  }

  /* ---- STICKY ATC BAR ---- */
  var stickyBar = document.getElementById('stickyAtcBar');
  var stickyBtn = document.getElementById('stickyAtcBtn');
  if (stickyBar && addToCartBtn) {
    var atcObserver = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    atcObserver.observe(addToCartBtn);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variantId = document.getElementById('selectedVariantId')
          ? parseInt(document.getElementById('selectedVariantId').value)
          : parseInt(addToCartBtn.dataset.variantId);
        doAddToCart(variantId, stickyBtn);
      });
    }
  }

  /* ---- REFRESH CART DRAWER ---- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); renderCartBody(cart); })
    .catch(function (err) { console.error('Cart refresh error:', err); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('#cartCount, #drawerItemCount').forEach(function (el) {
      el.textContent = el.id === 'cartCount'
        ? count
        : count + ' article' + (count !== 1 ? 's' : '');
    });
  }

  /* Prix en centimes (panier Shopify) → euros */
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Prix depuis suggest API (déjà en euros, format "35.00") */
  function moneyFromString(str) {
    return parseFloat(str).toFixed(2).replace('.', ',') + ' €';
  }

  function renderCartBody(cart) {
    var body    = document.getElementById('cartBody');
    var subtotal = document.getElementById('cartSubtotal');
    if (!body) return;
    if (subtotal) subtotal.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty-msg">Ton panier est vide.<br>No need… pour l\'instant.</p>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img class="cart-item__img" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="80" height="100">'
        : '<div class="cart-item__img"></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';

      html += '<div class="cart-item" data-key="' + item.key + '">'
        + '<a href="' + item.url + '">' + imgHtml + '</a>'
        + '<div>'
        + '<p class="cart-item__name">' + escapeHtml(item.product_title) + '</p>'
        + variantHtml
        + '<p class="cart-item__price">' + money(item.final_price) + '</p>'
        + '<div class="cart-item__qty">'
        + '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Diminuer">−</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button class="qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Augmenter">+</button>'
        + '</div>'
        + '<button class="cart-item__remove" data-key="' + item.key + '">Retirer</button>'
        + '</div></div>';
    });
    body.innerHTML = html;
    bindCartActions();
  }

  function bindCartActions() {
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key     = this.dataset.key;
        var action  = this.dataset.action;
        var qtyEl   = this.parentElement.querySelector('span');
        var current = parseInt(qtyEl.textContent);
        var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        updateCartLine(key, newQty);
      });
    });
    document.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () { updateCartLine(this.dataset.key, 0); });
    });
  }

  function updateCartLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); renderCartBody(cart); })
    .catch(function (err) { console.error('Update cart error:', err); });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  bindCartActions();

  /* ---- GALERIE PRODUIT (thumbs) ---- */
  var galleryMain  = document.getElementById('galleryMain');
  var thumbButtons = document.querySelectorAll('.product-gallery__thumbs button');

  thumbButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbButtons.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      if (galleryMain) { galleryMain.src = this.dataset.src; galleryMain.alt = this.dataset.alt; }
    });
  });

  /* ---- LIGHTBOX ---- */
  var lightbox      = document.getElementById('imgLightbox');
  var lightboxImg   = document.getElementById('lightboxImg');
  var lightboxClose = document.getElementById('lightboxClose');

  if (galleryMain && lightbox && lightboxImg) {
    galleryMain.addEventListener('click', function () {
      lightboxImg.src = this.src;
      lightboxImg.alt = this.alt;
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightboxClose) {
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- VARIANTS PRODUIT ---- */
  var variantDataEl = document.getElementById('productVariantsData');
  if (variantDataEl) {
    var variants = JSON.parse(variantDataEl.textContent);
    var selectedOptions = [];

    document.querySelectorAll('.variant-btns').forEach(function (group, idx) {
      var active = group.querySelector('.variant-btn.active');
      selectedOptions[idx] = active ? active.dataset.value : null;
    });

    document.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionIdx = parseInt(this.dataset.option);
        this.closest('.variant-btns').querySelectorAll('.variant-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        this.classList.add('active');
        selectedOptions[optionIdx] = this.dataset.value;

        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return selectedOptions[i] === undefined || selectedOptions[i] === opt;
          });
        });

        if (match) {
          var hiddenInput = document.getElementById('selectedVariantId');
          if (hiddenInput) hiddenInput.value = match.id;

          var atcBtn = document.getElementById('addToCartBtn');
          if (atcBtn) {
            atcBtn.dataset.variantId = match.id;
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
          }
          if (stickyBtn) {
            stickyBtn.disabled = !match.available;
            stickyBtn.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
          }

          var priceEl = document.getElementById('priceDisplay');
          if (priceEl) priceEl.textContent = money(match.price);

          if (match.featured_image && galleryMain) galleryMain.src = match.featured_image.src;
        }
      });
    });
  }

  /* ---- GUIDE DES TAILLES ---- */
  var sizeGuideBtn = document.getElementById('sizeGuideBtn');
  var sizeModal    = document.getElementById('sizeGuideModal');
  if (sizeGuideBtn && sizeModal) {
    sizeGuideBtn.addEventListener('click', function () { sizeModal.style.display = 'flex'; });
    sizeModal.addEventListener('click', function (e) {
      if (e.target === sizeModal) sizeModal.style.display = 'none';
    });
  }

  /* ---- RECENTLY VIEWED ---- */
  var rvDataEl    = document.getElementById('currentProductData');
  var rvContainer = document.getElementById('recentlyViewedGrid');

  if (rvDataEl) {
    try {
      var productInfo = JSON.parse(rvDataEl.textContent);
      var viewed = JSON.parse(localStorage.getItem('rdstg_recently_viewed') || '[]');
      viewed = viewed.filter(function (p) { return p.id !== productInfo.id; });
      viewed.unshift(productInfo);
      if (viewed.length > 6) viewed = viewed.slice(0, 6);
      localStorage.setItem('rdstg_recently_viewed', JSON.stringify(viewed));
    } catch (e) {}
  }

  if (rvContainer) {
    try {
      var currentId = rvContainer.dataset.currentId;
      var viewed    = JSON.parse(localStorage.getItem('rdstg_recently_viewed') || '[]');
      var others    = viewed.filter(function (p) { return String(p.id) !== String(currentId); });

      if (others.length > 0) {
        var html = '';
        others.slice(0, 4).forEach(function (p) {
          html += '<a href="' + p.url + '" class="rv-card">'
            + (p.image
              ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
              : '<div class="rv-card__placeholder"></div>')
            + '<p class="rv-card__name">' + escapeHtml(p.title) + '</p>'
            + '<p class="rv-card__price">' + escapeHtml(p.price) + '</p>'
            + '</a>';
        });
        rvContainer.innerHTML = html;
        var rvSection = document.getElementById('recentlyViewedSection');
        if (rvSection) rvSection.removeAttribute('hidden');
      }
    } catch (e) {}
  }

  /* ---- PREDICTIVE SEARCH ---- */
  var suggestionsBox = document.getElementById('searchSuggestions');
  var searchTimer;

  function hideSuggestions() {
    if (suggestionsBox) suggestionsBox.innerHTML = '';
  }

  if (searchInput && suggestionsBox) {
    searchInput.addEventListener('input', function () {
      var q = this.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { hideSuggestions(); return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var results = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (results.length === 0) { hideSuggestions(); return; }
            var html = '';
            results.forEach(function (p) {
              var imgSrc = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              /* L'API suggest retourne le prix en euros (ex: "35.00"), pas en centimes */
              var priceStr = p.price ? moneyFromString(p.price) : '';
              html += '<a href="' + p.url + '" class="suggestion-item">'
                + (imgSrc
                  ? '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" width="40" height="52">'
                  : '<div class="suggestion-item__placeholder"></div>')
                + '<span class="suggestion-item__name">' + escapeHtml(p.title) + '</span>'
                + '<span class="suggestion-item__price">' + priceStr + '</span>'
                + '</a>';
            });
            suggestionsBox.innerHTML = html;
          })
          .catch(function () { hideSuggestions(); });
      }, 300);
    });

    searchInput.addEventListener('blur', function () {
      setTimeout(hideSuggestions, 200);
    });
  }

  /* ---- COLLECTION FILTERS (client-side) ---- */
  var filterBtns     = document.querySelectorAll('.filter-btn');
  var collectionGrid = document.querySelector('.collection-grid');
  if (filterBtns.length > 0 && collectionGrid) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        var type = this.dataset.filter;
        collectionGrid.querySelectorAll('.product-card').forEach(function (card) {
          card.style.display = (type === 'all' || card.dataset.type === type) ? '' : 'none';
        });
      });
    });
  }

  /* ---- MICRO-ANIMATIONS (Intersection Observer) ---- */
  if ('IntersectionObserver' in window) {
    var fadeEls = document.querySelectorAll('.fade-in-up');
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(function (el) { fadeObserver.observe(el); });
  }

  /* ---- PAGE PANIER (qty +/- et remove) ---- */
  document.querySelectorAll('.page-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key     = this.dataset.key;
      var action  = this.dataset.action;
      var span    = this.parentElement.querySelector('span');
      var current = parseInt(span ? span.textContent : '1');
      var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('.cart-page__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---- COOKIE BANNER ---- */
  var cookieBanner = document.getElementById('cookieBanner');
  var cookieAccept = document.getElementById('cookieAccept');
  var cookieRefuse = document.getElementById('cookieRefuse');

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  if (cookieBanner) {
    if (!getCookie('rdstg_cookie_consent')) {
      cookieBanner.style.display = 'flex';
    } else {
      cookieBanner.classList.add('hidden');
    }
    if (cookieAccept) {
      cookieAccept.addEventListener('click', function () {
        setCookie('rdstg_cookie_consent', 'accepted', 365);
        cookieBanner.classList.add('hidden');
      });
    }
    if (cookieRefuse) {
      cookieRefuse.addEventListener('click', function () {
        setCookie('rdstg_cookie_consent', 'refused', 365);
        cookieBanner.classList.add('hidden');
      });
    }
  }

});
